<template>
<div class="model-13">
	<div class="notice-box notice-box-1" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color}">
		<div class="notice-con">
		  <div class="notice-con-icon">
			<img :src="notice_image">
		  </div>
		  <div class="notice-con-split">
		  </div>
		  <div class="notice-slid" :style="{top}">
			<div class="notice-con-font" @click="goAdUrl(v.link)" v-for="(v,index) in editablePageConfig.editable_page_config_content.notice_title" :key="index">{{v.text}}</div>
		  </div>
		</div>
	  </div>
</div>
</template>

<script>
export default {
  name: 'Model13',
  data () {
    return {
      activeIndex: 0
    }
  },
  props: ['editablePageConfig','editablePage'],
  computed: {
    top () {
      return -this.activeIndex * 39 + 'px'
    },
	notice_image(){
		if(this.editablePageConfig.editable_page_config_content['notice_image']){
			return this.editablePageConfig.editable_page_config_content['notice_image']
		}else{
			return env.SITE_URL+'/static/home/images/editable_page/ds-notice.png'
		}
	}
  },
  beforeDestroy: function () {
    clearInterval(this.time_interval)
  },
  mounted () {
    let _this = this
    this.time_interval = setInterval(function () {
      if (_this.activeIndex < _this.editablePageConfig.editable_page_config_content.notice_title.length-1) {
        _this.activeIndex += 1
      } else {
        _this.activeIndex = 0
      }
    }, 2000)
  },
  methods: {
    goAdUrl (url) {
      this.$router.push({path:url})
    }
  }
}
</script>

<style lang="scss" scoped>
.model-13 .notice-box-1 {
	padding: 10px;
	border-radius:5px;
}
.model-13 .notice-box-1 .notice-con {
	display: flex;
	align-items: center;
	height: 39px;
	line-height: 39px;
	overflow: hidden;
}
.model-13 .notice-box-1 .notice-con-icon {
	flex-shrink: 0;
	height: 12px;
	text-align: center;
	line-height: 18px;
}
.model-13 .notice-box-1 .notice-con-icon img {
	max-width: 100%;
	max-height: 100%;
	vertical-align: top;
}
.model-13 .notice-box-1 .notice-con-split {
	width: 1px;
	height: 13px;
	background-color: #E4E4E4;
	margin: 0 11px;
}
.model-13 .notice-box-1 .notice-slid{
	position: relative;
	transition: top .5s;
	flex: 1;
	align-self: flex-start;
}
.model-13 .notice-box-1 .notice-con-font {
	font-size: 14px;
	color: #333;
	flex: 1;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
</style>
